import {useCallback} from 'react';
import {useDispatch} from 'react-redux';
import {UPDATE_DESIGN_OPTIONS} from '~/common/fabric/reducers/fabricDesign/constants';

export function useNavigator({isMobile = false, disableAutoOpenEditor = false}) {
  const dispatch = useDispatch();
  return useCallback(
    (section) => {
      dispatch({
        type: UPDATE_DESIGN_OPTIONS,
        payload: {
          currentSection: section,
        },
      });
      if (isMobile) {
        dispatch({
          type: UPDATE_DESIGN_OPTIONS,
          payload: {editingMobile: !disableAutoOpenEditor},
        });
      }
    },
    [disableAutoOpenEditor, dispatch, isMobile]
  );
}
